'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toggleClassVisibilityForVenue = exports.setTapTouchButtonsInViewport = exports.setFiltersHidden = exports.setMsaId = exports.setKey = exports.setEnabledMobileFilters = exports.setBoxOLinksInViewport = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

exports.default = reducer;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SET_BOX_O_LINKS_IN_VIEWPORT = 'classpass/venue-filters/SET_BOX_O_LINKS_IN_VIEWPORT';
var SET_ENABLED_MOBILE_FILTERS = 'classpass/venue-filters/SET_ENABLED_MOBILE_FILTERS';
var SET_KEY = 'classpass/venue-filters/SET_KEY';
var SET_MSA_ID = 'classpass/venue-filters/SET_MSA_ID';
var SET_FILTERS_HIDDEN = 'classpass/venue-filters/SET_FILTERS_HIDDEN';
var SET_TAP_TOUCH_BUTTONS_IN_VIEWPORT = 'classpass/venue-filters/SET_TAP_TOUCH_BUTTONS_IN_VIEWPORT';
var TOGGLE_CLASS_VISIBILITY_FOR_VENUE = 'classpass/venue-filters/TOGGLE_CLASS_VISIBILITY_FOR_VENUE';

var setBoxOLinksInViewport = exports.setBoxOLinksInViewport = function setBoxOLinksInViewport(boxOLinksInViewport) {
  return { type: SET_BOX_O_LINKS_IN_VIEWPORT, data: { key: 'boxOLinksInViewport', value: boxOLinksInViewport } };
};
var setEnabledMobileFilters = exports.setEnabledMobileFilters = function setEnabledMobileFilters(filters) {
  return { type: SET_ENABLED_MOBILE_FILTERS, data: { key: 'enabledMobileFilters', value: filters } };
};
var setKey = exports.setKey = function setKey(key) {
  return { type: SET_KEY, data: { key: 'venueKey', value: key } };
};
var setMsaId = exports.setMsaId = function setMsaId(msaId) {
  return { type: SET_MSA_ID, data: { key: 'msaId', value: msaId } };
};
var setFiltersHidden = exports.setFiltersHidden = function setFiltersHidden(filtersHidden) {
  return { type: SET_FILTERS_HIDDEN, data: { key: 'filtersHidden', value: filtersHidden } };
};
var setTapTouchButtonsInViewport = exports.setTapTouchButtonsInViewport = function setTapTouchButtonsInViewport(tapTouchButtonsInViewport) {
  return { type: SET_TAP_TOUCH_BUTTONS_IN_VIEWPORT, data: { key: 'tapTouchButtonsInViewport', value: tapTouchButtonsInViewport } };
};
var toggleClassVisibilityForVenue = exports.toggleClassVisibilityForVenue = function toggleClassVisibilityForVenue(venueId, forceVisibility) {
  return { type: TOGGLE_CLASS_VISIBILITY_FOR_VENUE, data: { venueId: venueId, forceVisibility: forceVisibility } };
};

var initialState = function initialState() {
  return {
    boxOLinksInViewport: false,
    enabledMobileFilters: [],
    filtersHidden: true,
    tapTouchButtonsInViewport: false,
    venueIdWithClassesExpanded: {}
  };
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState();
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case SET_BOX_O_LINKS_IN_VIEWPORT:
    case SET_KEY:
    case SET_MSA_ID:
    case SET_ENABLED_MOBILE_FILTERS:
    case SET_FILTERS_HIDDEN:
    case SET_TAP_TOUCH_BUTTONS_IN_VIEWPORT:
      return (0, _extends4.default)({}, state, (0, _defineProperty3.default)({}, action.data.key, action.data.value));
    case TOGGLE_CLASS_VISIBILITY_FOR_VENUE:
      {
        var _action$data = action.data,
            venueId = _action$data.venueId,
            forceVisibility = _action$data.forceVisibility;

        var nextState = (0, _extends4.default)({}, state, {
          venueIdWithClassesExpanded: (0, _extends4.default)({}, state.venueIdWithClassesExpanded)
        });
        if (forceVisibility === false) {
          delete nextState.venueIdWithClassesExpanded[venueId];
        } else if (forceVisibility === true) {
          nextState.venueIdWithClassesExpanded[venueId] = true;
        } else if (state.venueIdWithClassesExpanded[venueId]) {
          delete nextState.venueIdWithClassesExpanded[venueId];
        } else {
          nextState.venueIdWithClassesExpanded[venueId] = true;
        }

        return nextState;
      }
    default:
      return state;
  }
}